var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[_c('Container',{staticClass:"crypto-currency",attrs:{"tag":"section"}},[_c('CryptoCurrency'),_c('CoinGeckoMention')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }